import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Career = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.206 7.928a7.927 7.927 0 0 1-7.925 7.928 7.927 7.927 0 0 1-7.925-7.928 7.927 7.927 0 1 1 15.85 0Zm-2.377 0a5.549 5.549 0 1 1-5.548-5.55 5.549 5.549 0 0 1 5.548 5.55ZM28.993 9.91a2.774 2.774 0 0 0-2.775 2.775v7.391c0 .22-.178.398-.398.397l-9.311-.038a2.774 2.774 0 0 0-2.785 2.775v7.4a.396.396 0 0 1-.395.396l-8.779.04a2.774 2.774 0 0 0-2.76 2.774v7.405A2.774 2.774 0 0 0 4.562 44h34.872a2.774 2.774 0 0 0 2.774-2.775V12.688a2.774 2.774 0 0 0-2.773-2.775L28.993 9.91Zm-.397 2.775c0-.219.177-.396.396-.396l10.443.003c.22 0 .396.177.396.396v28.537a.396.396 0 0 1-.396.397H4.563a.396.396 0 0 1-.396-.397V33.82c0-.218.176-.395.394-.397l8.78-.04a2.774 2.774 0 0 0 2.76-2.774V23.21c0-.22.179-.397.398-.396l9.312.037a2.774 2.774 0 0 0 2.785-2.774v-7.392Z"
  }));
});
Career.displayName = 'Career';
Career.defaultProps = {
  'aria-label': 'Career'
};
export default Career;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Career.js
// module id = 3741
// module chunks = 11